// import Vue from 'vue'
import Router from 'vue-router'
import { isMobile } from '@/lib/device'

import account from './root-account'
import person from './root-person'
import organization from './root-organization'
import invite from './root-invite'
import form from './root-form'
import full from './root-full'

import team from './project-team'
import statistic from './project-statistic'
import role from './project-role'
import cost from './project-cost'
import inquery from './project-inquery'
import config from './project-config'
import record from './project-record'
import smartForm from './project-smartForm'
import edm from './project-edm'

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    ...account,
    ...person,
    ...organization,
    ...invite,
    ...form,
    ...full,
    {
      path: '/project/:pid',
      name: 'ProjectLayout',
      props: true,
      component: () =>
        isMobile
          ? import(
            /* webpackChunkName: "mb-base" */ `@/components/mobile/ProjectLayout`
          )
          : import(
            /* webpackChunkName: "pc-base" */ `@/components/pc/ProjectLayout`
          ),
      children: [
        ...inquery,
        ...config,
        ...cost,
        ...statistic,
        ...role,
        ...team,
        ...record,
        ...smartForm,
        ...edm,
        isMobile
          ? {
            path: 'projectindex',
            name: 'ProjectIndex',
            component: () =>
                import(
                  /* webpackChunkName: "mb-base" */ `@/mobile/organization/ProjectIndex`
                ),
            meta: {
              title: '组织星轨询盘管理'
            }
          }
          : {
            path: 'home',
            name: '',
            redirect: () => {
              return {
                name: 'OrgIndex'
              }
            }
          },
        {
          path: 'm-404',
          name: 'MobileProject404',
          component: () => import(/* webpackChunkName: "mb-base" */ `@/mobile/organization/Project-404`)
        }
      ]
    },
    {
      path: '/',
      name: 'home',
      redirect: () => {
        return {
          name: 'OrgIndex'
        }
      }
    },
    {
      path: '/demo/index',
      name: 'demoIndex',
      component: () => import(`@/pc/demo/Index`)
    },
    {
      path: '*',
      redirect: to => {
        return {
          path: '/'
        }
      }
    },
    {
      path: '/mc/mobile',
      name: 'mobileCommon',
      component: () => isMobile ? import(/* webpackChunkName: "mb-base" */ `@/components/mobile/Common`) : ''
    }
  ]
})
